/**
 * @generated SignedSource<<440c5ea02584f2ac43262c47267fa928>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllMessagesScreen_MessagesPaginationFragment_RefetchQuery$variables = {
  after?: string | null;
  first?: number | null;
};
export type AllMessagesScreen_MessagesPaginationFragment_RefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AllMessagesScreen_MessagesPaginationFragment">;
};
export type AllMessagesScreen_MessagesPaginationFragment_RefetchQuery = {
  response: AllMessagesScreen_MessagesPaginationFragment_RefetchQuery$data;
  variables: AllMessagesScreen_MessagesPaginationFragment_RefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllMessagesScreen_MessagesPaginationFragment_RefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "AllMessagesScreen_MessagesPaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllMessagesScreen_MessagesPaginationFragment_RefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessagingViewerSchema",
            "kind": "LinkedField",
            "name": "Messaging",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "MessagesConnection",
                "kind": "LinkedField",
                "name": "Messages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessagesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageDefinition",
                            "kind": "LinkedField",
                            "name": "messageDefinition",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageDefinitionPagesConnection",
                                "kind": "LinkedField",
                                "name": "pages",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MessageDefinitionPagesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MessageDefinitionPage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "image",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "internalTitle",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MessageDefinition",
                                            "kind": "LinkedField",
                                            "name": "messageDefinition",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "buttonOpt",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isMessageDefinitionButtonInterface"
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v4/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "link",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "MessageDefinitionLinkButton",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v4/*: any*/)
                                                    ],
                                                    "type": "MessageDefinitionConfirmButton",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasSeen",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "AllmessagesScreen_Messages",
                "kind": "LinkedHandle",
                "name": "Messages"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "540a98671edc97acf63accd5d426d614",
    "id": null,
    "metadata": {},
    "name": "AllMessagesScreen_MessagesPaginationFragment_RefetchQuery",
    "operationKind": "query",
    "text": "query AllMessagesScreen_MessagesPaginationFragment_RefetchQuery(\n  $after: String\n  $first: Int\n) {\n  ...AllMessagesScreen_MessagesPaginationFragment_2HEEH6\n}\n\nfragment AllMessagesScreen_MessagesPaginationFragment_2HEEH6 on Query {\n  Viewer {\n    Messaging {\n      Messages(after: $after, first: $first) {\n        edges {\n          node {\n            id\n            messageDefinition {\n              pages {\n                edges {\n                  node {\n                    image {\n                      url\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n            ...MessagePreview_MessageFragment\n            ...MessageModal_MessageFragment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment ConfirmButton_MessageDefinitionConfirmButtonFragment on MessageDefinitionConfirmButton {\n  title\n}\n\nfragment LinkButton_MessageDefinitionLinkButtonFragment on MessageDefinitionLinkButton {\n  title\n  link\n}\n\nfragment MessageDefinitionButton_MessageDefinitionButtonFragment on MessageDefinitionButtonInterface {\n  __isMessageDefinitionButtonInterface: __typename\n  type\n  ... on MessageDefinitionLinkButton {\n    ...LinkButton_MessageDefinitionLinkButtonFragment\n  }\n  ... on MessageDefinitionConfirmButton {\n    ...ConfirmButton_MessageDefinitionConfirmButtonFragment\n  }\n}\n\nfragment MessageModal_MessageFragment on Message {\n  id\n  messageDefinition {\n    pages {\n      edges {\n        node {\n          id\n          image {\n            url\n            id\n          }\n          ...MessagePage_MessageDefinitionPageFragment\n        }\n      }\n    }\n    id\n  }\n  hasSeen\n}\n\nfragment MessagePage_MessageDefinitionPageFragment on MessageDefinitionPage {\n  image {\n    url\n    id\n  }\n  internalTitle\n  messageDefinition {\n    buttonOpt {\n      __typename\n      ...MessageDefinitionButton_MessageDefinitionButtonFragment\n    }\n    id\n  }\n}\n\nfragment MessagePreview_MessageFragment on Message {\n  messageDefinition {\n    pages {\n      edges {\n        node {\n          internalTitle\n          image {\n            url\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  hasSeen\n}\n"
  }
};
})();

(node as any).hash = "43baa427ef3b5c8ca50ef503779df549";

export default node;
